import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const NewsletterUnsubscribe = () => {
    const [formData, setFormData] = useState({
        email: "",
        dob: "",
    });

    useEffect(() => {
        window.scrollTo(0, 0)
    })

    const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.email || !formData.dob) {
            setAlert({ visible: true, message: "Please fill all required fields.", type: "danger" });
            setTimeout(() => setAlert({ visible: false, message: "", type: "" }), 3000);
            return;
        }

        setAlert({ visible: true, message: "You have unsubscribed successfully!", type: "success" });
        setTimeout(() => setAlert({ visible: false, message: "", type: "" }), 3000);

        setFormData({ email: "", dob: "" });
    };

    return (
        <div className="container mb-5">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="mt-4 mb-4">
                <ol className="breadcrumb">
                    {/* Home Link */}
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="fa-regular fa-folder me-2"></i> Unsubscribe
                    </li>
                </ol>
            </nav>

            {/* Overlay Alert */}
            {alert.visible && (
                <div className={`overlay-alert ${alert.type}`}>
                    <div className="alert-content d-flex align-items-center">
                        <i className="fa-solid fa-check me-2"></i>
                        <strong>{alert.type === "success" ? "Success!" : "Oops!"} </strong> {alert.message}
                        <button
                            type="button"
                            className="btn-close ms-auto"
                            onClick={() => setAlert({ visible: false, message: "", type: "" })}
                        ></button>
                    </div>
                    <div className="progress-bar"></div>
                </div>
            )}

            <div className="row justify-content-center">
                <div className="col-md-6">
                    <h2 className="mb-4 text-left">Unsubscribe from Newsletter</h2>
                    <form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm bg-light">
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Date of Birth</label>
                            <input
                                type="date"
                                name="dob"
                                className="form-control"
                                value={formData.dob}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <button type="submit" className="btn btn-danger w-100">
                            Unsubscribe
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NewsletterUnsubscribe;
